// src/constants/roles.js
export const ROLES = {
  ADMIN: 'admin',
  TEACHER: 'teacher',
  PARENT: 'parent',
  STUDENT: 'student',
  SUPER_ADMIN: 'super_admin',
}
